import $ from "jquery"
import ProfitLossReportEditConfigController from './ProfitLossReportEditConfigController'

export default class ProfitLossReportEditFormConfigController extends ProfitLossReportEditConfigController {}

ProfitLossReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    let result = $.extend({}, reportParameters)

    if (!EnabledFeatures.LVT) result.showLeaveTimeCosts = false

    if (!EnabledFeatures.OVR) result.showOvertimeAddition = false

    return result
}



// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ProfitLossReportEditFormConfigController.js